import { render, staticRenderFns } from "./EcallServiceItem.vue?vue&type=template&id=400e9334"
import script from "./EcallServiceItem.vue?vue&type=script&lang=js"
export * from "./EcallServiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports